"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fai-della-paganella": {
    "5ca57915": [{
      "hkey": "9e430d3e",
      "slug": "fai-della-paganella",
      "name": "Fai della Paganella",
      "primary": true,
      "skipSearch": false
    }],
    "al-plaz": [{
      "hkey": "9e430d3e",
      "slug": "fai-della-paganella",
      "name": "Fai della Paganella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "53dbebc8": [{
      "hkey": "9e430d3e",
      "slug": "fai-della-paganella",
      "name": "Fai della Paganella",
      "primary": true,
      "skipSearch": false
    }],
    "cortalta": [{
      "hkey": "9e430d3e",
      "slug": "fai-della-paganella",
      "name": "Fai della Paganella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;